<div class="rd-widget rd-widget-no-height-restriction widget-{{widgetConfig.widgetId}} valuation-summary-widget" *ngIf="widgetData">

  <table class="widget-large rd-textandlist-section-container" aria-hidden="true">
    <thead>
      <tr>
        <ng-container *ngIf="editMode">
          <th scope="col" colspan="3" class="widget-grid-column">
            <span class="k-icon k-i-minus" (click)="deleteCurrentRow(rows)"></span>
            <span class="k-icon k-i-plus" (click)="addRow(rows)" *ngIf="sectionHasAvailableFields('valuation-summary')"></span>
            <span class="k-icon k-i-arrow-up" (click)="moveCurrentRowUp(rows)"></span>
            <span class="k-icon k-i-arrow-down" (click)="moveCurrentRowDown(rows)"></span>
          </th>
        </ng-container>
        <th scope="col" colspan="10" class="widget-grid-column">
          <widget-value [align]="'left'" [color]="'white'" [bold]="true">{{'valuationSummary.labelMethodology' | rdTranslate}}</widget-value>
        </th>
        <ng-container *ngIf="!editMode">
          <th scope="col" colspan="3" class="widget-grid-column">
            &nbsp;
          </th>
        </ng-container>
        <th scope="col" colspan="11" class="widget-grid-column">
          <widget-value [align]="'left'" [color]="'white'" [bold]="true">{{'valuationSummary.labelValuation' | rdTranslate}}</widget-value>
        </th>
        <th scope="col" colspan="9" class="widget-grid-column" *ngIf="showWeightings">
          <widget-value [align]="'left'" [color]="'white'" [bold]="true">{{'valuationSummary.labelWeighting' | rdTranslate}}</widget-value>
        </th>
      </tr>
    </thead>
    <tbody>
      <rd-textandlist-section [widget]="this" [widgetId]="this.widgetConfig.widgetId" [page]="page" [selectedTag]="hashTag" [sectionName]="textAndListSectionName" [disableCustomLabels]="disableCustomLabels" [reflists]="reflists" [topicReflist]="'ref_l3_valuation_summary_methodology'"
                              [editMode]="editMode" [rows]="rows" [leftColspan]="13" [rightColspan]="20"
                              [data]="widgetData" [alternatingColorScheme]="true" [currency]="currency"
                              [unitOfArea]="unitOfArea" [addRow]="addRow$" [deleteCurrentRow]="deleteCurrentRow$"
                              [moveCurrentRowUp]="moveCurrentRowUp$" [moveCurrentRowDown]="moveCurrentRowDown$"
                              [rightColumnsTemplate]="rightColumnsTemplate"
                              (dataChanged)="onDataChanged()"
                              (sectionRowsCountChanged)="sectionRowsCountChanged($event)">
      </rd-textandlist-section>

      <tr class="light-grey-line text-bold">
        <td colspan="13"><widget-value [align]="'left'" [color]="'dark-gray'" [bold]="true">{{'valuationSummary.adoptedValue' | rdTranslate}}</widget-value></td>
        <td colspan="11"><widget-value [align]="'right'" [color]="'dark-gray'" [bold]="true">{{currency}} {{(widgetData.adoptedValue || 0) | rdLocalizedNumber:0}}</widget-value></td>
        <td colspan="9" *ngIf="showWeightings"></td>
      </tr>

    </tbody>
  </table>

</div>

<!-- CUSTOM TEMPLATE FOR RIGHT COLUMNS (AS WE HAVE "NONSTANDARD" TWO COLUMNS)-->
<ng-template let-row let-it="index" let-data="data" let-textAndListInstance="textAndListInstance" #rightColumnsTemplate>

  <ng-container *ngIf="editMode">
    <td colspan="11" class="text-and-list-view-mode-row">
      <widget-value [align]="'right'" [bold]="true"><span>{{currency}} </span>{{ data[row.fieldNameMiddle] | rdLocalizedNumber:0}}</widget-value>
    </td>
    <td colspan="9" *ngIf="showWeightings" [class.invalid]="weightingsInvalid">
      <div *ngIf="row.isNumericField && !row.readonly" class="d-flex" (click)="textAndListInstance.editRow(i)">
        <pollux-report-designer-numeric-field style="width: 100%" class="widget-input-text" ngDefaultControl [(value)]="data[row.fieldName]" [isNullable]="true" [decimals]="row.decimals || 0" [thousandsSeparators]="row.thousandsSeparators" (valueChange)="calculateAdoptedValue(); textAndListInstance.setDirtyFlag(true)"></pollux-report-designer-numeric-field>
      </div>
    </td>
  </ng-container>

  <ng-container *ngIf="!editMode">
    <td colspan="11" class="text-and-list-view-mode-row">
      <widget-value [align]="'right'" [bold]="true"><span>{{currency}} </span>{{ data[row.fieldNameMiddle] | rdLocalizedNumber:0}}</widget-value>
    </td>
    <td colspan="9" class="text-and-list-view-mode-row" *ngIf="showWeightings">
      <widget-value *ngIf="row.isNumericField" [align]="'right'" [bold]="true"><span *ngIf="row.isCurrency">{{currency}} </span>{{ data[row.fieldName] | rdLocalizedNumber:(row.decimals || 0)}}<span *ngIf="row.isArea">{{unitOfArea}}</span><span *ngIf="row.isPercentage"> %</span></widget-value>
    </td>
  </ng-container>

</ng-template>
